export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de movimientos"])},
          "title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Crear ", _interpolate(_named("movement_type"))])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])}
        }
      }
    }
  })
}